import * as React from "react";
const SvgArrowOutward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M5.723 20 17.54 8.185v10.584H20V4H5.23v2.462h10.585L4 18.277z"
    />
  </svg>
);
export default SvgArrowOutward;
